import React, { useEffect, useState } from "react";
import Navbar from "../../components/ui/navbar/sidenav.components";
// import Logo from "../../assets/images/Layer1.svg";
import { useNavigate } from "react-router-dom";
import "../dashboard/dashboard.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import restimg from "../../assets/images/torestimg.png";
import storepic from "../../assets/images/storesimg.png";
import eventspic from "../../assets/images/feimg.png";
import agentspic from "../../assets/images/totalagents.png";
import docpic from "../../assets/images/doc.png"
// import Cookies from 'js-cookie'
import Barchart from "../../components/ui/charts/bar-chart/bar-chart.components";
import Linechart from "../../components/ui/charts/line-chart/line-chart.components";
import Loader from "../../components/ui/loader/loader.components";
import { Calendar } from "primereact/calendar";
import {
  AgentsWeeklyPerformance,
  PopularCatogeriess,
  CuisinesChart,
  WeeklyApprovedRejected,
  RestaurantsAndUsersAdded,
  DashboardCards,
  ReviewsperDay,
  weeklyapprovedrejectedbydate,
  StoresandEvents,
  WeeklyApprovedRejectedStores,
  DietitianAdminCounts,
} from "../../api/dashboard.api";
import { getRefreshedToken, isTokenExpired, logout } from "../../api/auth.api";
import axios from "axios";
import Doughnutchart from "../../components/ui/charts/doughnut-chart/doughnut-chart.components";
import { response } from "express";
const Dashboard = () => {
  const [isAdding, setIsadding] = useState(false);
  const navigate = useNavigate();
  const [barData, setBarData] = useState<any>({ labels: [], data: [] });
  const [storebarData, setStorebarData] = useState<any>({ labels: [], data: [] });
  const [barData1, setBarData1] = useState<any>({ labels: [], data: [] });
  const [cusinechartData, setCusineChartData] = useState({});
  const [PopularCatogeries, setPopularCatogeries] = useState({});
  const [Restaurants, setRestaurants] = useState({});
  const [Organicstores, setOrganicstores] = useState({});
  const [dietitians, setDietitians] = useState({});
  const [agents, setAgents] = useState({});
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue("--text-color");
  const textColorSecondary = documentStyle.getPropertyValue(
    "--text-color-secondary"
  );
  const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

  const [cardsdata, setcardsdata] = useState<any>();
  const [sroresevents, setstoresevent] = useState<any>();
  const [dietitiansvalue, setDietitiansvalue] = useState<any>();
  const [fromdate, setfromDate] = useState<any>();
  const [todate, settoDate] = useState<any>();
  const [storefromdate, setstorefromdate] = useState<any>();
  const [storetodate, setstoretodate] = useState<any>();
  const [chartOptions, setChartOptions] = useState({});
  const [storeoption, setstoreoptions] = useState({});
  const [dietitianoptions, setDietitianoptions] = useState({});
  const [agentsoptions, setagentsoptions] = useState({});
  const [catoptions, setcatoptions] = useState({});
  const [cuisineoptions, setcuisineoptions] = useState({});
  const [restoptions, setrestoptions] = useState({});
  const [organicoptions, setorganicoptions] = useState({});
  const [reviewoptions, setreviewoptions] = useState({});


  const popcatdata = async () => {
    try {
      const PopcatCount = await PopularCatogeriess();
      // console.log("object pop cat dataaaaa", PopcatCount);
      const Popcatdata = {
        labels: PopcatCount.data.data.map((report: any) => report._id),
        datasets: [
          {
            data: PopcatCount.data.data.map((report: any) => report.count),
            backgroundColor: [
              "#62B2FD",
              "#9BDFC4",
              "#FAAFBC",
              "#B1ABF8",
              "#ACDDDE",
              "#F7D8BA",
              "#CEC9DF",
              "#E1E1E1",
              "#C8DCB8",
              "#A1A1D4"
            ],
            borderRadius: 15,
            hoverBorderWidth: 0,

          },
        ],
      };

      const options = {
        cutout: "65%",
        plugins: {
          legend: {
            display: false,
            position: "right",
            labels: {
              color: "#3c3c3c",
              font: {
                size: 12,
              },
              pointStyle: "circle",


            },
          },
        },
        elements: {
          arc: {
            spacing: 5,
          },
        },
        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "200px";
          chart.canvas.parentNode.style.height = "200px";
        },
      };

      setcatoptions(options);
      setPopularCatogeries(Popcatdata);
    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  };

  const cuisinedata = async () => {
    try {
      const CuisineCount = await CuisinesChart();
      // console.log("cusssss", CuisineCount);
      const Cuisinedata = {
        labels: CuisineCount.data.data.data.map((report: any) => report._id),
        datasets: [
          {
            data: CuisineCount.data.data.data.map(
              (report: any) => report.count
            ),
            backgroundColor: [
              "#62B2FD",
              "#9BDFC4",
              "#FAAFBC",
              "#B1ABF8",
              "#ACDDDE",
              "#F7D8BA",
              "#CEC9DF",
              "#E1E1E1",
              "#C8DCB8",
              "#A1A1D4"


            ],
            borderRadius: 15,
            hoverBorderWidth: 0,
          },
        ],
      };

      const options = {
        cutout: "65%",
        plugins: {
          legend: {
            display: false,
            position: "right",
            labels: {
              color: "#3c3c3c",
              font: {
                size: 12,
              },
              pointStyle: "circle",


            },
          },
        },
        elements: {
          arc: {
            spacing: 5,
          },
        },

        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "200px";
          chart.canvas.parentNode.style.height = "200px";
        },
      };

      setcuisineoptions(options)
      setCusineChartData(Cuisinedata);
    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  };
  const restaurantsdata = async () => {
    try {
      const restaurantsCount = await DashboardCards();
      console.log("restdashcount", restaurantsCount);
      const desiredKeys = ["Pending", "Approved", "Rejected"];
      const resultArray = [
        desiredKeys,
        desiredKeys.map((key) => restaurantsCount.data.data[key].toString()),
      ];
      const Restdata = {
        labels: resultArray[0],
        datasets: [

          {
            data: resultArray[1],
            backgroundColor: ["#62B2FD", "#9BDFC4", "#FAAFBC"],
            borderRadius: 15,
            hoverBorderWidth: 0,
          },

        ],
      };
      const options = {
        cutout: "65%",
        plugins: {
          legend: {
            display: false,
            position: "right",
            labels: {
              color: "#3c3c3c",
              font: {
                size: 12,
              },
              pointStyle: "circle",


            },
          },
        },
        elements: {
          arc: {
            spacing: 5,
          },
        },
        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "200px";
          chart.canvas.parentNode.style.height = "200px";
        },
      };


      setRestaurants(Restdata);
      setChartOptions(options);

    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  };

  const organicStoresData = async () => {
    try {
      const storesEventsData = await StoresandEvents();
      console.log("storesdashbordcount", storesEventsData);
      const desiredKeys = ["Pending", "Approved", "Denied"];
      const resultArray = [
        desiredKeys,
        desiredKeys.map((key) => storesEventsData.data.data[key].toString()),
      ];

      const organicStoresData = {
        labels: resultArray[0],
        datasets: [
          {
            data: resultArray[1],
            backgroundColor: ["#62B2FD", "#9BDFC4", "#FAAFBC"],
            borderRadius: 15,
            hoverBorderWidth: 0,
          },
        ],
      };
      const options = {
        cutout: "65%",
        plugins: {
          legend: {
            display: false,
            position: "right",
            labels: {
              color: "#3c3c3c",
              font: {
                size: 12,
              },
              pointStyle: "circle",


            },
          },
        },
        elements: {
          arc: {
            spacing: 5,
          },
        },
        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "200px";
          chart.canvas.parentNode.style.height = "200px";
        },
      };

      setstoreoptions(options)
      setOrganicstores(organicStoresData);
    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  };

  const DietitiansData = async () => {
    try {
      const GetDietitiansData = await DietitianAdminCounts();
      console.log("dietdashcount", GetDietitiansData);
      const desiredKeys = ["Pending", "Approved", "Denied"];
      const resultArray = [
        desiredKeys,
        desiredKeys.map((key) => GetDietitiansData.data.data[key].toString()),
      ];
      const DietitianresultsData = {
        labels: resultArray[0],
        datasets: [
          {
            data: resultArray[1],
            backgroundColor: ["#62B2FD", "#9BDFC4", "#FAAFBC"],
            borderRadius: 15,
            hoverBorderWidth: 0,
          },
        ],
      };
      const options = {
        cutout: "65%",
        plugins: {
          legend: {
            display: false,
            position: "right",
            labels: {
              color: "#3c3c3c",
              font: {
                size: 12,
              },
              pointStyle: "circle",


            },
          },
        },
        elements: {
          arc: {
            spacing: 5,
          },
        },
        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "200px";
          chart.canvas.parentNode.style.height = "200px";
        },
      };
      setDietitianoptions(options);
      setDietitians(DietitianresultsData)

    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  }

  const AgentsData = async () => {
    try {
      const restaurantsCount = await DashboardCards();
      const desiredKeys = ["TotalActiveAgents"];
      const resultArray = [
        desiredKeys,
        desiredKeys.map((key) => restaurantsCount.data.data[key].toString()),
      ];
      const Restdata = {
        labels: resultArray[0],
        datasets: [
          {
            data: resultArray[1],
            backgroundColor: [

              "#9BDFC4",
              "#FAAFBC",

            ],

            borderWidth: 10,
          },

        ],
      };

      const options = {
        cutout: "50%",
        plugins: {
          legend: {
            display: false,
            position: "right",
            labels: {
              color: "#3c3c3c",
              font: {
                size: 12,
              },
              pointStyle: "circle",


            },
          },
        },

        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "200px";
          chart.canvas.parentNode.style.height = "200px";
        },
      };

      setagentsoptions(options);
      setAgents(Restdata);

    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }

    }
  }

  const DateSelection = async () => {
    try {
      const datawithDate = await weeklyapprovedrejectedbydate(
        formatDate(fromdate),
        formatDate(todate)
      );
      // console.log("Data with dates:", datawithDate);

      const mergedArray = datawithDate.ApprovedCount.map((approvedData: { _id: any; count: any; }) => {
        const matchingRejectedData = datawithDate.RejectedCount.find((rejectedData: { _id: any; }) => rejectedData._id === approvedData._id);
        return {
          _id: approvedData._id,
          approvedCount: approvedData.count,
          rejectedCount: matchingRejectedData ? matchingRejectedData.count : 0
        };
      });

      // console.log("Merged Array for restaurant:", mergedArray);

      const data = {
        labels: mergedArray.map((entry: any) => entry._id),
        datasets: [
          {
            label: "Approved",
            backgroundColor: "#9BDFC4",
            borderColor: "#9BDFC4",
            data: mergedArray.map((entry: { approvedCount: any; }) => entry.approvedCount),
            barThickness: 5,
            borderRadius: 100,
          },
          {
            label: "Rejected",
            backgroundColor: "#FAAFBC",
            borderColor: "#FAAFBC",
            data: mergedArray.map((entry: { rejectedCount: any; }) => entry.rejectedCount),
            barThickness: 5,
            borderRadius: 100,
          },
        ],
      };

      const options = {
        maintainAspectRatio: false,
        aspectRatio: 1,

        plugins: {
          legend: {
            display: false, // Hide the legend
            position: "bottom",
            align: "start",
          },
        },
        scales: {
          x: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder,
            },
          },
          y: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder,
            },
          },
        },

        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "100%";
          chart.canvas.parentNode.style.height = "320px";
        },
      };


      setrestoptions(options)
      setBarData(data);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 400) {
        logout();
        navigate("/");
      } else {
        // Handle other errors
      }
    }
  };

  const formatDate = (date: any) => {
    if (!date) return "";

    if (typeof date === "string" && date.includes("/")) {
      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    }

    return new Date(date).toLocaleDateString('en-GB');
  };

  const StoresDateSelection = async () => {
    try {
      const storeswithdate = await WeeklyApprovedRejectedStores(
        formatDate(storefromdate),
        formatDate(storetodate)
      );

      // console.log("stores data with dates", storeswithdate);

      const mergedArray = storeswithdate.ApprovedCount.map((approvedStore: { _id: any; count: any; }) => {
        const matchingRejectedStore = storeswithdate.RejectedCount.find((rejectedStore: { _id: any; }) => rejectedStore._id === approvedStore._id);
        return {
          _id: approvedStore._id,
          approvedCount: approvedStore.count,
          rejectedCount: matchingRejectedStore ? matchingRejectedStore.count : 0
        };
      });

      // console.log("mergedArray for stores", mergedArray);

      const data = {
        labels: mergedArray.map((entry: any) => entry._id),
        datasets: [
          {
            label: "Approved",
            backgroundColor: "#9BDFC4",
            borderColor: "#9BDFC4",
            data: mergedArray.map((entry: { approvedCount: any; }) => entry.approvedCount),
            barThickness: 5,
            borderRadius: 100,
            barPercentage: 0.7,
            categoryPercentage: 0.8
          },
          {
            label: "Rejected",
            backgroundColor: "#FAAFBC",
            borderColor: "#FAAFBC",
            data: mergedArray.map((entry: { rejectedCount: any; }) => entry.rejectedCount),
            barThickness: 5,
            borderRadius: 100,
            barPercentage: 0.4,
            categoryPercentage: 0.5
          },
        ],
      };


      const options = {
        maintainAspectRatio: false,
        aspectRatio: 1,

        plugins: {
          legend: {
            display: false, // Hide the legend
            position: "bottom",
            align: "start",
          },
        },
        scales: {
          x: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder,
            },
          },
          y: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder,
            },
          },
        },

        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "100%";
          chart.canvas.parentNode.style.height = "320px";
        },
      };

      setorganicoptions(options);
      setStorebarData(data);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 400) {
        logout();
        navigate("/");
      } else {
        // Handle other errors
      }
    }
  };

  const userreviewsperday = async () => {
    try {
      const reviewdata = await ReviewsperDay();
      console.log("reviewcountdddd", reviewdata);
      const mergedArray = reviewdata.data.restaurantReviews.map((restaurantReview: { _id: any; count: any; }) => {
        const matchingStoreReview = reviewdata.data.storeReviews.find((storeReview: { _id: any; count: any; }) => storeReview._id === restaurantReview._id);
        const matchingDietitianReviews = reviewdata.data.dietitianReviews.find((dietitianReview: { _id: any; count: any; }) => dietitianReview._id === restaurantReview._id)
        return {
          _id: restaurantReview._id,
          restaurantCount: restaurantReview.count,
          storeCount: matchingStoreReview ? matchingStoreReview.count : 0,
          dietCount: matchingDietitianReviews ? matchingDietitianReviews.count : 0
        };
      });



      const restaurantDataset = {
        label: 'Restaurants',
        backgroundColor: "#62B2FD",
        borderColor: "#62B2FD",
        data: mergedArray.map((entry: { restaurantCount: any; }) => entry.restaurantCount),
        barThickness: 5,
        borderRadius: 100,
        barPercentage: 0.7,
        categoryPercentage: 0.8
      };

      const storeDataset = {
        label: 'Organic Stores',
        backgroundColor: "#B1ABF8",
        borderColor: "#B1ABF8",
        data: mergedArray.map((entry: { storeCount: any; }) => entry.storeCount),
        barThickness: 5,
        borderRadius: 100,
        barPercentage: 0.7,
        categoryPercentage: 0.8
      };

      const dietitianDataset = {
        label: "Dietitians",
        backgroundColor: "#9BDFC4",
        borderColor: "#9BDFC4",
        data: mergedArray.map((entry: { dietCount: any; }) => entry.dietCount),
        barThickness: 5,
        borderRadius: 100,
        barPercentage: 0.7,
        categoryPercentage: 0.8
      }

      const datasets = [restaurantDataset, storeDataset, dietitianDataset];

      const reviews = {
        labels: mergedArray.map((entry: any) => entry._id),
        datasets: datasets
      };


      const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
          legend: {
            display: false,
            labels: {
              color: textColor,
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              display: false
            },
            title: {
              display: true,
              text: "Star Rating",
              color: textColor,
              font: {
                size: 14,
              },
            },
          },
          y: {
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 10,
            ticks: {
              color: textColorSecondary,
              stepSize: 2,
              callback: function (value: any) {
                return Number.isInteger(value) ? value : null;
              }
            },
            grid: {
              color: surfaceBorder,
              // borderDash: [5, 5],
            },
            title: {
              display: true,
              text: "No. of Reviews",
              color: textColor,
              font: {
                size: 14,
               
              },
            },
          },
        },
        onResize: (chart: any, size: any) => {
          chart.canvas.parentNode.style.width = "100%";
          chart.canvas.parentNode.style.height = "180px";
        },
      };


      setBarData1(reviews);
      setreviewoptions(options);

    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  };

  const dashbaorddata = async () => {
    try {
      const Dashboard = await DashboardCards();
      setcardsdata(Dashboard.data.data);
    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  };
  const Dashboardstoresandevents = async () => {
    try {
      const dashboardstoreevents = await StoresandEvents();
      setstoresevent(dashboardstoreevents.data.data)

    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  }
  const DashboardDietitiansData = async () => {
    try {
      const dashboarddietitiansData = await DietitianAdminCounts();
      setDietitiansvalue(dashboarddietitiansData.data.data)
    } catch (err: any) {
      if (err.response?.status === 401) {
        logout();
        navigate("/");
      }
    }
  }

  useEffect(() => {
    setIsadding(true);
    dashbaorddata();
    Dashboardstoresandevents();
    DashboardDietitiansData();
    organicStoresData();
    DietitiansData();
    AgentsData();
    popcatdata();
    cuisinedata();
    userreviewsperday();
    restaurantsdata();
    setIsadding(false);
  }, []);

  useEffect(() => {
    DateSelection();
  }, [fromdate, todate]);

  useEffect(() => {
    StoresDateSelection();
  }, [storefromdate, storetodate]);


  return (
    <>
      <main>
        {!isAdding ? "" : <Loader />}

        <div>
          <Navbar />
          <section className="page-content">
            <div className="ym-content-table">
              <div className="container-fluid">

                <div className="pl-2">
                  <h1 className='dashboard-heading'>Dashboard</h1>
                </div>
                <hr style={{ margin: "0px" }} />
                <div className="section1div mb-4 p-2">
                  <div className="col-lg-12 d-flex flex-wrap  justify-content-between">
                    <div className="total-rests d-flex align-items-center gap-3 p-2">
                      <div className="total-rest-image-div d-flex align-items-center justify-content-center">
                        <img className="pic-pic" src={restimg} alt="pic" />
                      </div>
                      <div className="totalrest-count">
                        <p className="count-value">{cardsdata?.Total}</p>
                        <p className="count-heading">Total Restaurants</p>
                      </div>

                    </div>


                    <div className="d-flex flex-column gap-2">
                      <div className="total-rests d-flex align-items-center gap-3 p-2">
                        <div className="total-store-image-div d-flex align-items-center justify-content-center">
                          <img className="pic-pic" src={storepic} alt="pic" />
                        </div>
                        <div className="totalrest-count">
                          <p className="count-value">{sroresevents?.Total}</p>
                          <p className="count-heading">Total Organic Stores</p>
                        </div>

                      </div>
                    </div>

                    <div className="d-flex flex-column gap-2">
                      <div className="total-rests d-flex align-items-center gap-3 p-2">
                        <div className="total-diet-image-div d-flex align-items-center justify-content-center">
                          <img className="pic-pic" src={docpic} alt="pic" />
                        </div>
                        <div className="totalrest-count">
                          <p className="count-value">{dietitiansvalue?.Total}</p>
                          <p className="count-heading">Total Dietitians</p>
                        </div>

                      </div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="total-rests d-flex align-items-center gap-3 p-2">
                        <div className="total-events-image-div d-flex align-items-center justify-content-center">
                          <img className="pic-pic" src={eventspic} alt="pic" />
                        </div>
                        <div className="totalrest-count">
                          <p className="count-value">{sroresevents?.TotalEvents}</p>
                          <p className="count-heading">Total Food Events</p>
                        </div>

                      </div>


                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="total-rests d-flex align-items-center gap-3 p-2">
                        <div className="total-agents-image-div d-flex align-items-center justify-content-center">
                          <img className="pic-pic" src={agentspic} alt="pic" />
                        </div>
                        <div className="totalrest-count">
                          <p className="count-value">{cardsdata?.TotalAgents}</p>
                          <p className="count-heading">Total Agents</p>
                        </div>

                      </div>

                    </div>

                  </div>
                </div>

                <div className="section2div d-flex gap-1  p-2 mb-4 col-lg-12">
                  <div className="rest-chart-div col-lg-4">
                    <span className="chart-head">Restaurants</span>
                    <div className="chart-top-bodies d-flex align-items-center justify-content-around mt-2 p-2">
                      <div className=" d-flex  align-items-center">
                        <div>
                          <Doughnutchart
                            data={Restaurants as any}
                            options={chartOptions as any}
                          />
                        </div>

                      </div>
                      <div className="d-flex flex-column gap-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#9BDFC4" }}></i>
                          <span className="text-chart-opt mr-3">Approved</span>
                          <span className="text-chart-opt">{cardsdata?.Approved}</span>
                        </div>
                        <div className="d-flex  align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#FAAFBC" }}></i>
                          <span className="text-chart-opt mr-3">Rejected</span>
                          <span className="text-chart-opt">{cardsdata?.Denied}</span>
                        </div>
                        <div className="d-flex  align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#62B2FD" }}></i>
                          <span className="text-chart-opt mr-3">Pending</span>
                          <span className="text-chart-opt">{cardsdata?.Pending}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="stores-chart-div col-lg-4">
                    <span className="chart-head">Organic Stores</span>
                    <div className="chart-top-bodies d-flex align-items-center justify-content-around mt-2">
                      <div className=" d-flex justify-content-around align-items-center">
                        <div>
                          <Doughnutchart
                            data={Organicstores as any}
                            options={storeoption as any}
                          />
                        </div>

                      </div>
                      <div className="d-flex flex-column gap-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#9BDFC4" }}></i>
                          <span className="text-chart-opt mr-3">Approved</span>
                          <span className="text-chart-opt">{sroresevents?.Approved}</span>
                        </div>
                        <div className="d-flex  align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#FAAFBC" }}></i>
                          <span className="text-chart-opt mr-3">Rejected</span>
                          <span className="text-chart-opt">{sroresevents?.Denied}</span>
                        </div>
                        <div className="d-flex  align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#62B2FD" }}></i>
                          <span className="text-chart-opt mr-3">Pending</span>
                          <span className="text-chart-opt">{sroresevents?.Pending}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 agents-chart-div">
                    <span className="chart-head">Dietitians</span>
                    <div className="chart-top-bodies d-flex align-items-center justify-content-around mt-2">
                      <div className=" d-flex justify-content-around align-items-center">
                        <div>
                          <Doughnutchart
                            data={dietitians as any}
                            options={dietitianoptions as any}
                          />
                        </div>

                      </div>
                      <div className="d-flex flex-column gap-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#9BDFC4" }}></i>
                          <span className="text-chart-opt mr-3">Approved</span>
                          <span className="text-chart-opt">{dietitiansvalue?.Approved}</span>
                        </div>
                        <div className="d-flex  align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#FAAFBC" }}></i>
                          <span className="text-chart-opt mr-3">Rejected</span>
                          <span className="text-chart-opt">{dietitiansvalue?.Denied}</span>
                        </div>
                        <div className="d-flex  align-items-center">
                          <i className="pi pi-circle-on mr-2" style={{ color: "#62B2FD" }}></i>
                          <span className="text-chart-opt mr-3">Pending</span>
                          <span className="text-chart-opt">{dietitiansvalue?.Pending}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

              {/* second */}

              {/* <div className="d-flex align-items-center justify-content-between mb-4 pl-3 pr-3">
                <div className="weekgraph p-2">
                  <div className="week-head" >{" "}Weekly Status of Restaurants</div>

                  <div className="mt-2">

                    <div className="row">
                      <div className="col-12">
                        <Barchart data={barData} options={restoptions as any} />
                      </div>
                    </div>
                    <div className="d-flex gap-4 justify-content-end">
                      <div className="d-flex align-items-center calen" style={{ width: "125px", height: "32px" }}>

                        <Calendar
                          value={fromdate}
                          onChange={(e) => setfromDate(e.target.value)}
                          showIcon
                          placeholder="From Date"
                        // dateFormat="dd/mm/yy"
                        />
                      </div>
                      <div className="d-flex align-items-center calen" style={{ width: "125px", height: "32px" }}>

                        <Calendar
                          value={todate}
                          onChange={(e) => settoDate(e.target.value)}
                          showIcon
                          placeholder="To Date"
                        // dateFormat="dd/mm/yy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="weekgraph p-2">
                  <div className="week-head" >{" "}Weekly Status of Organic Stores</div>

                  <div className="mt-2">

                    <div className="row">
                      <div className="col-12">
                        <Barchart data={storebarData} options={organicoptions as any} />
                      </div>
                    </div>
                    <div className="d-flex gap-4 justify-content-end">
                      <div className="d-flex align-items-center calen" style={{ width: "125px", height: "32px" }}>

                        <Calendar
                          value={storefromdate}
                          onChange={(e) => setstorefromdate(e.target.value)}
                          showIcon
                          placeholder="From Date"

                        // dateFormat="dd/mm/yy"
                        />
                      </div>
                      <div className="d-flex align-items-center calen" style={{ width: "125px", height: "32px" }}>

                        <Calendar
                          value={storetodate}
                          className=""
                          onChange={(e) => setstoretodate(e.target.value)}
                          showIcon
                          placeholder="To Date"
                        // dateFormat="dd/mm/yy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}


              <div className="row pl-3 pr-3 justify-content-around">
                <div className="col-xl-3 col-lg-3 col-md-3 mb-2 p-3">
                  <div
                    className="week-head mb-2"

                  >
                    {" "}
                    Popular Catogeries
                  </div>


                  <div className="chart-body d-flex justify-content-center align-items-center">
                    <div className="row justify-content-center align-items-center">
                      <Doughnutchart
                        data={PopularCatogeries}
                        options={catoptions}
                      />
                    </div>
                  </div>

                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 mb-2 p-3">
                  <div
                    className="week-head mb-2"

                  >
                    {" "}
                    Cuisines
                  </div>

                  <div className="chart-body d-flex justify-content-center align-items-center">

                    <div className="row justify-content-center align-items-center ">
                      <Doughnutchart
                        data={cusinechartData}
                        options={cuisineoptions}
                      />
                    </div>

                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4 mb-2 p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="week-head mb-2">Reviews</div>

                    <div className="d-flex justify-content-center  gap-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <i className="pi pi-circle-on mr-2" style={{ color: "#62B2FD" }}></i>
                        <span className="text-chart-opt mr-3">Restaurants</span>

                      </div>
                      <div className="d-flex  align-items-center">
                        <i className="pi pi-circle-on mr-2" style={{ color: "#B1ABF8" }}></i>
                        <span className="text-chart-opt mr-3">Organic Stores</span>
                      </div>
                      <div className="d-flex  align-items-center">
                        <i className="pi pi-circle-on mr-2" style={{ color: "#9BDFC4" }}></i>
                        <span className="text-chart-opt mr-3">Dietitians</span>
                      </div>
                    </div>
                  </div>

                  <div className="chart-body ">

                    <div className="pt-4 px-3">
                      <Barchart data={barData1} options={reviewoptions as any} />
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default Dashboard;
